import { Typography } from '@mui/material';


function DMCA(){
	
	return (
    <div className='container' style={{ padding: "64px 1vw 64px 3vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
      Removal of Content from miwatchfacs.com
      </Typography>
      
									<p>The following describes the process for submitting a take down notice or filing a counter-notice in
									accordance with the <a href="https://en.wikipedia.org/wiki/Digital_Millennium_Copyright_Act">Digital
									Millenium Copyright Act</a> (DMCA). Please note that there are legal repercussions for filing a false notice
									or counter-notice.
									</p>
									<br />
									<h3>How to submit a take down notice</h3>
									<p>
									Please send all take down notices via <a href="/contact">the contact form</a>.
									</p>
									<p>
									The following items should be included with your request in accordance with the <a href="https://en.wikipedia.org/wiki/Digital_Millennium_Copyright_Act">DMCA</a>:
									</p>
									<ul>
									<li>Identification of the copyrighted work that has been allegedly infringed</li>
									<li>The specific URL where the material can be found</li>
									<li>A statement of the good faith belief that there has been no authorized usage granted by the owner,
									agent or law</li>
									<li>Your contact information (full name and email address) to allow for
									follow up to the submitted request</li>
									<li>A statement that under the penalty of perjury, you are authorized to act on behalf of the owner of
									the allegedly infringed material</li>
									<li>Your physical or electronic signature</li>
									</ul>
									<p>Please note that requests missing any of the above information cannot be honored.</p>
									<br />
									<h3>How to file a counter-notice</h3>
									<p>
									Please send all counter-notices via <a href="/contact">the contact form</a>.
									</p>
									<p>
									If you believe that your content has been removed in error, please include the following in your request for
									reinstatement of said content in accordance with the <a href="https://en.wikipedia.org/wiki/Digital_Millennium_Copyright_Act">DMCA</a>:
									</p>
									<ul>
									<li>Identification and the original location the material that was removed (or a reasonably specific
									description of the material)</li>
									<li>A statement, under penalty of perjury, that the material was removed due to mistake or
									misidentification by the party who requested removal</li>
									<li>Your name, address and phone number</li>
									<li>Your consent to (a) federal court jurisdiction local to the address (if outside of the United
									States to an appropriate judicial body) and (b) to accept service of process from the party requesting
									removal</li>
									<li>Your physical or electronic signature</li>
									</ul>
									<p>Please note that requests missing any of the above information cannot be honored.</p>
      
    </div>
	);
}
export default DMCA